module.exports = __webpack_public_path__ + "static/MI-6bc40f88f1ac5fb781996970f8468524.svg";